var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "header" }, [
    _c(
      "div",
      { staticClass: "header-content" },
      [
        _c("div", { staticClass: "header-logo" }, [
          _c("img", {
            attrs: { src: _vm.headerLogo, alt: "" },
            on: {
              click: function ($event) {
                return _vm.redirectPage("/home")
              },
            },
          }),
        ]),
        _c(
          "ul",
          [
            _vm.showHeaderMenu
              ? _vm._l(_vm.defaultMenu, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      attrs: { "data-active": _vm.checkMenuActive(item.path) },
                    },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.redirectPage(item.path)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                    ]
                  )
                })
              : _vm._e(),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.redirectPage("/login")
                  },
                },
              },
              [_vm._v("注册 | 登录")]
            ),
          ],
          1
        ),
        _vm.$i18n.locale === "en"
          ? _c(
              "el-link",
              {
                attrs: { type: "primary", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.changeLanguage("zh")
                  },
                },
              },
              [_vm._v("中文")]
            )
          : _c(
              "el-link",
              {
                attrs: { type: "primary", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.changeLanguage("en")
                  },
                },
              },
              [_vm._v("英文")]
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }